export type AIAgent = 'openai' | 'claude' | 'gemini' | null;

/**
 * Detects if the current user agent is an AI crawler/agent
 * @param userAgent - The user agent string to check (defaults to navigator.userAgent)
 * @returns The detected AI agent type or null if not an AI agent
 */
export function detectAIAgent(userAgent?: string): AIAgent {
  const ua = (
    userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '')
  ).toLowerCase();

  // OpenAI crawlers
  if (
    ua.includes('gptbot') ||
    ua.includes('chatgpt-user') ||
    ua.includes('oai-searchbot')
  ) {
    return 'openai';
  }

  // Anthropic/Claude crawlers
  if (
    ua.includes('anthropic-ai') ||
    ua.includes('claude-web') ||
    ua.includes('claude-user')
  ) {
    return 'claude';
  }

  // Google AI/Gemini crawlers
  if (ua.includes('google-extended') || ua.includes('googleother')) {
    return 'gemini';
  }

  return null;
}

/**
 * Checks if the current user agent is an AI crawler
 * @param userAgent - The user agent string to check (defaults to navigator.userAgent)
 * @returns true if the user agent is an AI crawler
 */
export function isAIAgent(userAgent?: string): boolean {
  return detectAIAgent(userAgent) !== null;
}
